<div class="modal-header justify-content-between" *ngIf="!embedded">
    <div class="modal-title pull-left d-flex align-items-center">
        <h4 class="fw-normal m-0 text-uppercase"></h4>
    </div>
    <button type="button" class="btn-close close ms-1" aria-label="Close" (click)="bsModalRef.hide()">
        <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
</div>
<div *ngIf="isLoading" class="modal-body modal-fixed-height d-flex align-items-center justify-content-center">
    <div class="text-center py-4">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
        </div>
        <p class="mt-2 text-muted mb-0">Loading preview...</p>
    </div>
</div>
<div *ngIf="!isLoading && signedLink" class="modal-body modal-fixed-height">
    <ng-container *ngIf="isImage; else iframePreview">
        <div class="image-preview-root">
            <div class="zoom-toolbar d-flex align-items-center justify-content-center flex-wrap gap-2 py-2 px-3">
                <button
                    type="button"
                    class="btn btn-sm zoom-toolbar__btn"
                    (click)="zoomOut()"
                    [disabled]="imageZoomPercent <= minZoomPercent"
                    aria-label="Zoom out"
                    title="Zoom out"
                >
                    <i class="fa-solid fa-minus" aria-hidden="true"></i>
                </button>
                <span class="zoom-toolbar__label">{{ imageZoomPercent }}%</span>
                <button
                    type="button"
                    class="btn btn-sm zoom-toolbar__btn"
                    (click)="zoomIn()"
                    [disabled]="imageZoomPercent >= maxZoomPercent"
                    aria-label="Zoom in"
                    title="Zoom in"
                >
                    <i class="fa-solid fa-plus" aria-hidden="true"></i>
                </button>
                <button
                    type="button"
                    class="btn btn-sm zoom-toolbar__reset"
                    (click)="resetImageZoom()"
                    title="Reset zoom to 50%"
                >
                    Reset
                </button>
            </div>
            <div class="image-container">
                <img
                    [src]="signedLink | safeUrl"
                    class="document-image"
                    [style.width.%]="imageZoomPercent"
                    alt="Document preview"
                />
            </div>
        </div>
    </ng-container>
    <ng-template #iframePreview>
        <iframe [src]="signedLink | safeUrl" width="100%" height="99%" frameborder="0"></iframe>
    </ng-template>
</div>
